import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { showApiErrorToast } from '@/utils/errors';

interface ExportButtonProps {
  onExport: () => Promise<void>;
  disabled?: boolean;
  label?: string;
}

export function ExportButton({ onExport, disabled, label = 'Excel' }: ExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false);

  async function handleClick() {
    setIsExporting(true);
    try {
      await onExport();
      toast.success('Export downloaded');
    } catch (error) {
      showApiErrorToast(error, 'Failed to export');
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      className="gap-2"
      onClick={() => void handleClick()}
      disabled={disabled || isExporting}
    >
      {isExporting ? <Loader2 className="size-4 animate-spin" /> : <Download className="size-4" />}
      {label}
    </Button>
  );
}
